import { render, staticRenderFns } from "./noticeList2.vue?vue&type=template&id=129d1c92&scoped=true"
import script from "./noticeList2.vue?vue&type=script&lang=js"
export * from "./noticeList2.vue?vue&type=script&lang=js"
import style0 from "./noticeList2.vue?vue&type=style&index=0&id=129d1c92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129d1c92",
  null
  
)

export default component.exports